import { styled } from "@mui/material/styles";
import { blue, grey } from "@mui/material/colors";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

export const CardNotFlexFullHeight = styled(Card)(({ theme }) => ({
  padding: 12,
  height: "100% !important",
  width: "100% !important",
  borderRadius: 16,
  backgroundColor: grey["200"],
  "& .MuiPaper-root": {
    height: "100% !important",
    width: "100% !important",
    color: grey[100],
  },
  "&:hover, &.Mui-focusVisible": {
    cursor: "pointer",
    backgroundColor: grey[400],
  },
}));

export const ClickableBox = styled(Box)(({ theme, bgColor }) => ({
  padding: 12,
  borderRadius: 8,
  backgroundColor: bgColor || grey["100"],
  "&:hover": {
    cursor: "pointer",
    backgroundColor: blue["100"],
  },
}));

export const StyledContainerBox = styled(Box)(({ padding, bgColor }) => ({
  padding: padding || 12,
  borderRadius: 8,
  backgroundColor: bgColor || grey["50"],
}));

export const DottedBorderBox = styled(Box)({
  border: "5px dotted black",
  padding: "16px",
  borderRadius: "4px",
});

export const BoxResponsivePadding = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    padding: 0,
  },
  [theme.breakpoints.up("md")]: {
    padding: "50px",
  },
}));

export const ReportItemStack = styled(Stack)(({ backgroundColor }) => ({
  padding: 3,
  backgroundColor: backgroundColor || grey[100],
  borderRadius: 8,
  "& > *": {
    margin: "0 4px", // Adjust the spacing between items as needed
  },
}));
